import { loadTranslations, saveTranslations } from '../services/translationApi'
import axios from 'axios'

export default {
  props: {
    isos: {
      type: Array,
      default: () => [],
    },
    languages: {
      type: Object,
      default: () => ({}),
    },
    flagCdnUrl: {
      type: String,
      default: '/images/flags/',
    },
  },

  data() {
    return {
      translations: {},
      mediaFiles: {},
      localIsos: null,
      localLanguages: null,
    }
  },

  computed: {
    resolvedIsos() {
      return this.localIsos ?? this.isos
    },
    resolvedLanguages() {
      return this.localLanguages ?? this.languages
    },
    primaryIso() {
      return this.resolvedIsos[0] || 'de'
    },
    isMultiLang() {
      return this.resolvedIsos.length > 1
    },
  },

  methods: {
    async fetchClientIsos(clientId) {
      if (!clientId) return
      try {
        const { data } = await axios.get('/backend/translations/client-isos/' + clientId)
        this.localIsos = data.isos
        this.localLanguages = data.languages
      } catch (e) {
        console.warn('Failed to fetch client isos', e)
      }
    },

    async loadTranslations(modelClass, modelId, fields = [], pathPrefix = '') {
      if (!this.isMultiLang || !modelId) return
      try {
        const data = await loadTranslations(modelClass, modelId, fields)
        const textTranslations = data.text_translations || {}
        const mediaFiles = data.media_files || {}
        Object.keys(textTranslations).forEach(field => {
          this.$set(this.translations, pathPrefix + field, textTranslations[field])
        })
        Object.keys(mediaFiles).forEach(field => {
          this.$set(this.mediaFiles, pathPrefix + field, mediaFiles[field])
        })
      } catch (e) {
        console.warn('Failed to load translations', e)
      }
    },

    async saveTranslations(modelClass, modelId, clientId) {
      if (!this.isMultiLang || !modelId) return
      try {
        await saveTranslations(
          modelClass,
          modelId,
          clientId,
          this.translations,
          this.mediaFiles,
        )
      } catch (e) {
        console.warn('Failed to save translations', e)
      }
    },

    getTranslation(fieldPath, iso) {
      return this.translations[fieldPath]?.[iso] || ''
    },

    getMediaUrl(fieldPath, iso) {
      return this.mediaFiles[fieldPath]?.[iso] || null
    },

    setTranslation(fieldPath, iso, value) {
      if (!this.translations[fieldPath]) {
        this.$set(this.translations, fieldPath, {})
      }
      this.$set(this.translations[fieldPath], iso, value)
    },

    setMediaUrl(fieldPath, iso, url) {
      if (!this.mediaFiles[fieldPath]) {
        this.$set(this.mediaFiles, fieldPath, {})
      }
      this.$set(this.mediaFiles[fieldPath], iso, url)
    },

    translationPayload() {
      return {
        _text_translations: this.translations,
        _media_files: this.mediaFiles,
      }
    },

    flagUrl(iso) {
      const code = iso === 'en' ? 'gb' : iso
      return this.flagCdnUrl + code + '.svg'
    },
  },
}
